var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"products-header"},[(_vm.loading)?_c(_setup.LoaderIndicator,{attrs:{"size":"48","with-container":"","min-height":"200"}}):_c('div',{staticClass:"products-header__hero"},[_c('div',{staticClass:"products-header__hero-info"},[_vm._t("loaded")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }